const description = {
  text: 'Powerbet.la es propiedad de y está operado por interplay tech ltd. Número de registro: 000038107, domicilio social: 2118 Guava Street..',
  more: 'Leer más',
  less: 'Leer menos',
  longText: 'Powerbet.la es propiedad de y está operado por interplay tech ltd. Número de registro: 000038107, domicilio social: 2118 Guava Street. Contáctenos en info@interplay.tech. Powerbet.la está autorizado y regulado por el Gobierno de la Isla Autónoma de Anjouan, Unión de las Comoras, y opera con la licencia n.° ALSI-032401020-FI3. Powerbet.la ha cumplido con todas las normativas y está legalmente autorizado para realizar operaciones de juego en todos los juegos de azar',
};

const footer = [
  {
    name: 'Platipus',
    image: '/img/v2/home/sponsors/platipus.webp',
  },
  {
    name: 'Gamebeat',
    image: '/img/v2/home/sponsors/gamebeat.webp',
  },
  {
    name: '1spin',
    image: '/img/v2/home/sponsors/1spin.webp',
  },
  {
    name: 'Nolimit',
    image: '/img/v2/home/sponsors/nolimit.webp',
  },
];

export default { description, footer };
